import { jsx } from 'react/jsx-runtime';
import { LockIcon, CakeIcon, CalendarIcon, CreditCardIcon, LocationIcon, EnvelopeIcon, PrivateIcon, SearchIcon, CountryIcon, CityIcon } from '../Icons/Icons.esm.js';

var INPUT_ICONS = {
    secure: LockIcon,
    cake: CakeIcon,
    calendar: CalendarIcon,
    creditCard: CreditCardIcon,
    location: LocationIcon,
    email: EnvelopeIcon,
    privacy: PrivateIcon,
    search: SearchIcon,
    country: CountryIcon,
    city: CityIcon
};
var InputIcon = function(param) {
    var icon = param.icon, className = param.className;
    var IconComponent = INPUT_ICONS[icon];
    return /*#__PURE__*/ jsx(IconComponent, {
        alt: icon,
        className: className,
        role: "img"
    });
};

export { INPUT_ICONS, InputIcon };
